import * as $ from 'jquery';
import * as Cookies from 'js-cookie';

export class siteGeneral {

	/**
	 * Repair all broken srcset url strings from aem
	 * - trigger log in console for broken image names
	 */
	 srcsetFix(): void {

	 	let imgEl = document.querySelectorAll('[srcset]');
	 	for (let i = 0, len = imgEl.length; i < len; i++) {
	 		let srcset = imgEl[i].getAttribute('srcset');
	 		let fixedSrcset:string;

	 		// fix wrong backslash encoding in url
	 		if (srcset.indexOf('\\2f ') > -1) {
	 			fixedSrcset = srcset.replace(/\\2f/g, '/');
	 			imgEl[i].setAttribute('srcset', fixedSrcset);
		 		console.log('Please consider using underscores or hyphens when naming images\n', window.location.hostname + srcset + '.');
	 		}

	 		srcset = imgEl[i].getAttribute('srcset');

	 		// fix whitespace in url
	 		if (srcset.indexOf(' ') > -1) {
	 			fixedSrcset = srcset.replace(/ /g, '%20');
	 			imgEl[i].setAttribute('srcset', fixedSrcset);
		 		console.log('Please consider using underscores or hyphens when naming images\n', window.location.hostname + srcset + '.');
	 		}
	 	}
	}

	sessionStorage(): boolean {
		try {
			window.sessionStorage.setItem('testKey', '1');
			window.sessionStorage.removeItem('testKey');
			return true;
		} catch (error) {
			return false;
		}
	}

	localStorage(): boolean {
		try {
			window.localStorage.setItem('testKey', '1');
			window.localStorage.removeItem('testKey');
			return true;
		} catch (error) {
			return false;
		}
	}
}

let scope:Element = document.querySelector('body');

if (scope){
	try {
		$(document).ready(function() {
			let site = new siteGeneral();
			site.srcsetFix();
		});
	} catch(e) {console.error(e);}
}
